import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { Button } from '../../components/Button';
interface Product {
  title: string;
  price: string;
  category: string;
  image: string;
  href: string;
}
const products: Product[] = [{
  title: 'Gen3-PSS-Gloves USAT',
  price: '$69.00',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
  href: '/m5/EPRO%2029943--Official-Daedo-Gen3-Gloves.html'
}, {
  title: 'Gen3 E-Foot Gear',
  price: '$110.84',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
  href: '/m5/EPRO%2029039--gen3-e-foot-gear.html'
}, {
  title: 'Gen3 Transmitter TK-Strike (Head)',
  price: '$556.85',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/32CSZRc127TCj3au4ThHui/GEN3_TRANSMITTER_TK-STRIKE_(HEAD).webp',
  href: '/m5/EPRO%2029902-U-0--gen3-e-head-transmitter-tk-strike-head.html'
}, {
  title: 'Gen3 Transmitter TK-Strike (Body)',
  price: '$459.35',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/1ih3djYezzVq8985HX8oSL/GEN3_TRANSMITTER_TK-STRIKE_(BODY).webp',
  href: '/m5/EPRO%2029901-U-0--gen3-transmitter-tk-strike-body.html'
}, {
  title: 'TK-Strike Gen3 Receiver',
  price: '$688.34',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/55DtFd96dsvi8vp6TjTcGE/TK-STRIKE_GEN3_RECEIVER.webp',
  href: '/m5/EPRO%2029926-U-0--tk-strike-gen3-receiver.html'
}, {
  title: 'Gen3 Electronic Body Protector',
  price: '$847.22',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/nf6K7oc2o7k9Lq2qdDp2cD/Red-GEN3_ELECTRONIC_BODY_PROTECTOR.webp',
  href: '/m5/EPRO%202990--gen3-e-hogus.html'
}, {
  title: 'Gen3 E-Head Gear',
  price: '$399.99',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/pZymF2e8PGGmiMTnD1QNCR/Red-and-BlueGEN3_E-HEAD_GEAR.webp',
  href: '/m5/EPRO%2029913--gen3-e-head-gear.html'
}, {
  title: 'Gen 3 Software Download',
  price: '$99.99',
  category: 'Gen 3',
  image: 'https://cdn.magicpatterns.com/uploads/uzhJjiwifSbakuQBq1HFz4/Gen3_Software_download.png',
  href: '/m5/EPRO%2029907-U-0--gen3-software-download.html'
}];
/**
 * Home page featured products section — grid of Gen 3 highlights.
 */
export function FeaturedProducts() {
  return <section className="py-20 bg-gray-50" data-id="element-651">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-652">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-653">
          <div data-id="element-654">
            <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-655">
              Featured Equipment
            </h2>
            <div className="w-24 h-1 bg-red-600 mt-4" data-id="element-656"></div>
            <p className="mt-4 text-gray-600 font-medium max-w-2xl" data-id="element-657">
              Top-rated Daedo gear trusted by athletes worldwide.
            </p>
          </div>
          <Button href="/shop/" variant="secondary" className="mt-6 md:mt-0 hidden md:inline-flex" data-id="element-658">
            Shop All Products
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-659">
          {products.map(product => <div key={product.title} className="group flex flex-col bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 border-2 border-red-500" data-id="element-660">
              <a href={product.href} className="relative aspect-square bg-gray-100 p-4 flex items-center justify-center overflow-hidden block hover:opacity-90 transition-opacity" data-id="element-661">
                <img src={product.image} alt={product.title} className="block w-full h-full object-contain relative z-[1]" data-id="element-662" />
                <span className="absolute top-3 left-3 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider z-10" data-id="element-663">
                  New
                </span>
              </a>

              <div className="p-5 flex flex-col flex-grow" data-id="element-664">
                <span className="text-xs text-blue-600 font-semibold uppercase tracking-wider mb-1" data-id="element-665">
                  {product.category}
                </span>
                <a href={product.href} data-id="element-666">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 hover:text-red-600 transition-colors" data-id="element-667">
                    {product.title}
                  </h3>
                </a>
                <div className="mt-auto pt-4 flex items-center justify-between" data-id="element-668">
                  <span className="text-xl font-extrabold text-gray-900" data-id="element-669">
                    {product.price}
                  </span>
                  <Button href={product.href} variant="primary" className="!py-2 !px-3" aria-label={`View ${product.title}`} data-id="element-670">
                    <ShoppingCartIcon className="w-5 h-5" data-id="element-671" />
                  </Button>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-672">
          <Button href="/shop/" variant="secondary" className="w-full" data-id="element-673">
            Shop All Products
          </Button>
        </div>
      </div>
    </section>;
}